import Axios from 'axios';
import JSencrypt from 'jsencrypt';
import systemConfig from '~config/config';
import ERROR_TYPE from '~common/js/error-type.js';
const dataServiceBaseUrl = systemConfig.dataService.baseURL;
/* 
const getCookie = (key) => {
  let cookieKey = key + "="; 
  let result = "";
  const cookieArr = document.cookie.split(";");
  
  for(let i = 0; i < cookieArr.length; i++) {
    if(cookieArr[i][0] === " ") {
      cookieArr[i] = cookieArr[i].substring(1);
    }
    
    if(cookieArr[i].indexOf(cookieKey) === 0) {
      result = cookieArr[i].slice(cookieKey.length, cookieArr[i].length);
      return result;
    }
  }
  return result;
} */

class AuthManager {
  login() {
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/api/v1/security/login',
        headers: {
         // 20211007 : localStorage->cookie 로 변경하면서 headers에 있는 accessToken 정보가 아니라 Cookie에서 직접 정보를 읽어와서 Auth 체크를 하기 때문에
          'Authorization' : 'Bearer '+ (sessionStorage.getItem('accessToken') ? sessionStorage.getItem('accessToken') : ''),
          'X-PathName': encodeURI(location.pathname),
        },
      };
      Axios(config).then((response) => {
        if (response.data.errorType) {
          const error = response.data;
          if(error.errorType === ERROR_TYPE.REDIRECT || error.errorType === ERROR_TYPE.SESSION_EXPIRED) {
        	// localStorage.setItem('accessToken', '');
        	sessionStorage.setItem('accessToken', '');
            if (error.errorMessage.startsWith('/')) { // 포털 내 이동
              window.location.pathname = error.errorMessage;
            } else { // 연계 시스템으로 이동
              window.location.href = error.errorMessage;
            }
          }
          reject('auth err');
        } else {
          resolve(response.data);
        }
      }).catch(error => {
        console.log(error.message);
        reject('auth err');
      })
    });
  }

  loginDirectly(data) { // 포털 자체 로그인
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/login',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) { // 비정상 테넌트
          if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
            window.location.pathname = response.data.errorMessage;
          }
          reject(response.data);

        } else { // 정상 테넌트
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  sendOtp(data) { // OTP 메일 발송
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/otp/send',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) { // 비정상 테넌트
          if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
            window.location.pathname = response.data.errorMessage;
          }
          reject(response.data);

        } else { // 정상 테넌트
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  verifyOtp(data) { // OTP 확인
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/otp/verify',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) { // 비정상 테넌트
          if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
            window.location.pathname = response.data.errorMessage;
          }
          reject(response.data);

        } else { // 정상 테넌트
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  resetPassword(data) { // 비밀번호 재설정
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/password',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) { // 비정상 테넌트
          if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
            window.location.pathname = response.data.errorMessage;
          }
          reject(response.data);

        } else { // 정상 테넌트
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }
  
  getPrivacyPolicy() { // 정보처리방침 조회

    return new Promise((resolve, reject) => {
      const config = {
        method: 'get',
        baseURL: dataServiceBaseUrl,
        url: '/certification/privacy-policy',

      };

      Axios(config).then((response) => {
        if (response.data.errorType) {
          reject(response.data);

        } else {
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  checkTenantAndLogin() { // 테넌트 및 로그인 여부 확인
    return new Promise((resolve, reject) => {
      if (window.location.pathname === '/start') { // 테넌트와 무관한 공통 화면
        resolve('no ccUrl');

      } else {
        const ccUrl = window.location.pathname.split('/')[2]; // pathname(/home/{ccUrl} 형식)에서 ccUrl 추출
        if (!!ccUrl && window.location.pathname.startsWith('/home/')) { // pathname 형식이 정상적인 경우, 서버에서 유효한 테넌트 여부 확인
          const config = {
            method: 'get',
            baseURL: dataServiceBaseUrl,
            url: '/certification/tenant/' + ccUrl,
          };
    
          Axios(config).then((response) => {
            if (response.data.errorType) { // 비정상 테넌트
              if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
                window.location.pathname = response.data.errorMessage;
              } else {
                window.location.pathname = '/certification/missingurl';
              }
              reject('invalid tenant');

            } else { // 정상 테넌트
              resolve(response.data);
            }
    
          }).catch(error => {
            reject(error);
          });

        } else if (window.location.pathname === '/') { // 테넌트 접속경로가 없는 경우
          window.location.pathname = '/start';

        } else { // pathname 형식이 비정상적인 경우
          window.location.pathname = '/certification/missingurl';
          reject('invalid pathname');
        }
      }
    });
  }

  changePassword(data) { // 만료 비밀번호 변경
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/password/change',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) { // 비정상 테넌트
          if(response.data.errorType === ERROR_TYPE.REDIRECT) { // redirect
            window.location.pathname = response.data.errorMessage;
          }
          reject(response.data);

        } else { // 정상 테넌트
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  getInviteUserInfo(token) { //토큰 이용하여 사용자 초대 정보 확인
	    return new Promise((resolve, reject) => {
	      const config = {
	        method: 'get',
	        baseURL: dataServiceBaseUrl,
	        url: '/certification/inviteUserInfo',
	        params: {
	          token: token,
	        }
	      };

	      Axios(config).then((response) => {
	        if (response.data.errorType) {
	          reject(response.data);

	        } else {
	          resolve(response.data);
	        }

	      }).catch(error => {
	        reject(error);
	      });
	    });
  }
            
  getTermsList() { // 악관 동의 확인
	    return new Promise((resolve, reject) => {
	      const config = {
	        method: 'get',
	        baseURL: dataServiceBaseUrl,
	        url: '/certification/policy/confirm',
	      };

	      Axios(config).then((response) => {
	        if (response.data.errorType) {
	          reject(response.data);

	        } else {
	          resolve(response.data);
	        }

	      }).catch(error => {
	        reject(error);
	      });
	    });
  }
  
  updateTermsList(termsUserListTmp) { // 악관 동의 업데이트
	    return new Promise((resolve, reject) => {
	      const config = {
	        method: 'put',
	        baseURL: dataServiceBaseUrl,
	        url: '/certification/policy/agree',
	        data : {
	          termsUserList:termsUserListTmp,
	      }
	      };

	      Axios(config).then((response) => {
	        if (response.data.errorType) {
	          reject(response.data);

	        } else {
	          resolve(response.data);
	        }

	      }).catch(error => {
	        reject(error);
	      });
	    });
  }

  getContactCenterNm(data) { // AICC 이름 조회
    return new Promise((resolve, reject) => {
      const config = {
        method: 'get',
        baseURL: dataServiceBaseUrl,
        url: '/certification/cc-nm/' + data,
      };

      Axios(config).then((response) => {
        resolve(response.data);

      }).catch(error => {
        reject(error);
      });
    });
  }

  createUser(data) { // 회원 정보 등록
    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/user/create',
        data,
      };

      Axios(config).then((response) => {
        if (response.data.errorType) {
          reject(response.data);

        } else {
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }

  encrypt(data) { // 서버에서 공개키를 조회하여 평문을 RSA 암호화
    return new Promise((resolve, reject) => {
      const config = {
        method: 'get',
        baseURL: dataServiceBaseUrl,
        url: '/certification/encryption/public-key',
      };

      Axios(config).then((response) => {
        const encrypt = new JSencrypt();
        encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + response.data.publicKey + '-----END PUBLIC KEY-----');
        resolve(encrypt.encrypt(data));
        
      }).catch(error => {
        reject(error);
      });
    });
  }

  removeSession() { // session 삭제

    return new Promise((resolve, reject) => {
      const config = {
        method: 'post',
        baseURL: dataServiceBaseUrl,
        url: '/certification/remove-session',

      };

      Axios(config).then((response) => {
        if (response.data.errorType) {
          reject(response.data);

        } else {
          resolve(response.data);
        }

      }).catch(error => {
        reject(error);
      });
    });
  }
}

export default new AuthManager();
